// extracted by mini-css-extract-plugin
export default {"container":"TariffAccordion_container__DZMKx","title":"TariffAccordion_title__wln0X"};